import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { ITeam } from 'src/app/model/user-management/team';
import { UNUSED_ARGS } from 'src/app/utility/unused-arguments';
import { TeamService } from '../../team/team.service';

@Injectable({
  providedIn: 'root'
})
export class TeamsResolverService  {
  constructor(private teamService: TeamService) { }

  private async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<ITeam[]> {
    UNUSED_ARGS(route, state);

    return await firstValueFrom(this.teamService.getTeamList());
  }
}
